export default __webpack_public_path__ + "tmp_src/components/SiteHeader/SiteHeader~nova.css.liquid";